import { AloftPrice, isUndefined } from '@aloft/toolkit-shared';
import { createSelectorCreator, lruMemoize } from '@reduxjs/toolkit';

export const createPriceSelector = createSelectorCreator(lruMemoize, {
  resultEqualityCheck: (prev: AloftPrice, curr: AloftPrice) => {
    if (isUndefined(prev) || isUndefined(curr) || typeof prev.compare !== 'function') {
      return prev === curr;
    }

    return prev.compare(curr) === 0;
  },
  maxSize: 50,
});
